<template>
    <dv-border-box-12 class="item-container">
        <div class="item-title">产废企业总量TOP 5</div>
        <!-- <dv-scroll-ranking-board :config="config" /> -->
        <my-scroll-ranking-board :config="config" :click="click" />
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */
import EventBus from "../js/event-bus.js";
import MyScrollRankingBoard from "../datav/MyScrollRankingBoard.vue";

export default {
    components: {
        MyScrollRankingBoard,
    },
    name: "enterproseTotalTop5",
    data() {
        return {
            config: null,
        };
    },
    mounted() {
        this.getData();
        EventBus.$on("inventoryChangedEvent", (row) => {
            this.getData();
        });
    },
    methods: {
        click(id) {
            EventBus.$emit("enteriseDblClickEvent", {
                organizationId: id,
            });
        },
        getData() {
            this.$api
                .getOutputTopN()
                .then((result) => {
                    if (
                        result.ok === true &&
                        result.data &&
                        result.data.length > 0
                    ) {
                        var temp = result.data.map(function (x) {
                            return {
                                id: x.organizationId,
                                name: x.organizationName,
                                value: x.total,
                            };
                        });
                        this.config = {
                            data: temp,
                            unit: " kg",
                        };
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style lang="less">
.item-container {
    .border-box-content {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .item-title {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        text-indent: 20px;
        margin: 10px 0;
    }
}
</style>
